import type {
	MusicHome,
	MusicLibrary,
	MusicMood,
	MusicPage,
	MusicPlayback,
	MusicPlaylist,
	MusicPreferences,
	MusicTrack
} from '@andresot/protocol/music';
import { request } from './client';
const base = '/api/music';
export const restoreMusicQueue = (ids: string[]) =>
	request<MusicPage>(`${base}/queue`, { body: { ids } });
export const fetchMusicHome = () => request<MusicHome>(`${base}/home`);
export const fetchMusicLibrary = () => request<MusicLibrary>(`${base}/library`);
export const fetchMusicTrack = (id: string) =>
	request<{ track: MusicTrack }>(`${base}/tracks/${encodeURIComponent(id)}`);
export const fetchMusicPlayback = (id: string) =>
	request<MusicPlayback>(`${base}/tracks/${encodeURIComponent(id)}/playback`);
export const searchMusic = (q: string, genre = '', offset = 0) =>
	request<MusicPage>(
		`${base}/search?${new URLSearchParams({ q, offset: String(offset), ...(genre ? { genre } : {}) })}`
	);
export const fetchMusicWave = (mood: MusicMood, exclude: string[] = []) =>
	request<MusicPage>(`${base}/wave`, { body: { mood, exclude: exclude.slice(-200) } });
export const saveMusicPreferences = (body: MusicPreferences) =>
	request<MusicPreferences>(`${base}/preferences`, { method: 'PUT', body });
export const musicFeedback = (id: string, action: 'like' | 'dislike' | 'history', enabled = true) =>
	request<{ ok: true }>(`${base}/tracks/${encodeURIComponent(id)}/${action}`, {
		method: enabled ? 'PUT' : 'DELETE'
	});
export const clearMusicHistory = () =>
	request<{ ok: true }>(`${base}/history`, { method: 'DELETE' });
export const createMusicPlaylist = (title: string) =>
	request<{ playlist: MusicPlaylist }>(`${base}/playlists`, { body: { title } });
export const saveMusicPlaylist = (
	playlist: MusicPlaylist,
	tracks = playlist.tracks,
	title = playlist.title
) =>
	request<{ playlist: MusicPlaylist }>(`${base}/playlists/${playlist.id}`, {
		method: 'PUT',
		body: { title, trackIds: tracks.map((t) => t.id), revision: playlist.revision }
	});
export const deleteMusicPlaylist = (id: string) =>
	request<{ ok: true }>(`${base}/playlists/${id}`, { method: 'DELETE' });
